import React from 'react';
import PropTypes from 'prop-types';

export const SupportTicketsSection = (props) => {
    return (
        <div className="support-tickets-section section" id="support-tickets">
            <div className="row content">
                <div className="col-12 col-sm-4 header">
                    <h4>Support Tickets</h4>
                    <p>The general support tickets you have created.</p>
                </div>
                <div className="col-12 col-sm-8">
                    {props.supportTickets.map(ticket => 
                        <div className="row ticket-row" key={ticket.id} onClick={() => props.onClick(ticket.id.toString())}>
                            <div className="col-4">
                                {ticket.createdDate}
                            </div>
                            <div className="col-4">
                                {ticket.status}
                            </div>
                            <div className="col-4">
                                {ticket.subject}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

SupportTicketsSection.propTypes = {
    supportTickets: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired
};

export default SupportTicketsSection;

